'use strict';

const storeLocator = require('../storeLocator/storeLocator');

var isCart = $('[data-action="Cart-Show"]').length > 0;
var currentUUID;
var currentShipmentUUID = null;

// ID Selectors
const inStoreInventoryModalID = '#inStoreInventoryModal';
const bopisMethodRadioBtnID = '#bopisMethodRadioButton';

// Class Selectors
const inStoreInventoryBtnClass = '.btn-get-in-store-inventory';
const quantitySelectClass = '.quantity-select';
const storeNameClass = '.store-name';
const productDetailClass = '.product-detail';
const sizeSelectedClasses = '.size-value.selected';

// Attribute Selectors
const dataStoreIDAttr = 'data-store-id';
const storeATSClass = '.store-ats';

/**
 * Restores Quantity Selector to its original state.
 * @param {HTMLElement} $quantitySelect - The Quantity Select Element
 */
function restoreQuantityOptions($quantitySelect) {
    var originalHTML = $quantitySelect.data('originalHTML');
    if (originalHTML) {
        $quantitySelect.html(originalHTML);
    }
}

/**
 * Sets the data attribute of Quantity Selector to save its original state.
 * @param {HTMLElement} $quantitySelect - The Quantity Select Element
 */
function setOriginalQuantitySelect($quantitySelect) {
    if (!$quantitySelect.data('originalHTML')) {
        $quantitySelect.data('originalHTML', $quantitySelect.html());
    } // If it's already there, don't re-set it
}

/**
 * Updates the Quantity Selector based on the In Store Quantity.
 * @param {string} quantitySelector - Quantity Selector
 * @param {string} quantityOptionSelector - Quantity Option Selector
 * @param {number} productAtsValue - Inventory in the selected store
 */
function updateQOptions(quantitySelector, quantityOptionSelector, productAtsValue) {
    var selectedQuantity = $(quantitySelector).val();
    restoreQuantityOptions($(quantitySelector));
    for (var i = $(quantityOptionSelector).length - 1; i >= productAtsValue; i -= 1) {
        $(quantityOptionSelector).eq(i).remove();
    }
    $(quantitySelector + ' option[value="' + selectedQuantity + '"]').attr('selected', 'selected');
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($(inStoreInventoryModalID).length !== 0) {
        $(inStoreInventoryModalID).remove();
    }
    var modalCloseTitle = $(inStoreInventoryBtnClass).data('modal-close-text');

    var htmlString = '<!-- Modal -->'
        + '<div class="modal " id="inStoreInventoryModal" role="dialog">'
        + '<div class="modal-dialog in-store-inventory-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header justify-content-end">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" title="' + modalCloseTitle + '">'
        + '      <svg role="img" class="icon svg-icon close-icon" width="16" height="16" aria-label="close">'
        + '        <title>close</title>'
        + '        <desc>close</desc>'
        + '        <use xlink:href="#close-icon"></use>'
        + '      </svg>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body select-store-modal px-4"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $(inStoreInventoryModalID).modal('show');
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 * @param {string} actionURL - The action url for this context
 */
function fillModalElement(pid, quantity, selectedPostalCode, selectedRadius, actionURL) {
    var requestData = {
        products: pid + ':' + quantity
    };

    if (typeof (selectedRadius) !== 'undefined') {
        requestData.radius = selectedRadius;
    }

    if (typeof (selectedPostalCode) !== 'undefined') {
        requestData.postalCode = selectedPostalCode;
    }

    $(inStoreInventoryModalID).spinner().start();

    $.ajax({
        url: actionURL,
        data: requestData,
        method: 'GET',
        success: function (response) {
            var modal = $('.modal-body.select-store-modal');
            modal.empty();
            modal.html(response.storesResultsHtml);

            modal.attr('data-current-uuid', currentUUID).attr('data-current-shipment-uuid', currentShipmentUUID);

            storeLocator.search();
            storeLocator.changeRadius();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();

            $('.btn-storelocator-search').attr('data-search-pid', pid);

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();
            }

            $(inStoreInventoryModalID).modal('show');
            $(inStoreInventoryModalID).spinner().stop();
        },
        error: function (err) {
            $(inStoreInventoryModalID).spinner().stop();
            // eslint-disable-next-line no-console
            console.error('Error while filling modal element: ' + err.message);
        }
    });
}

/**
 * Update quantity options. Only display quantity options that are available for the store.
 * @param {string} searchPID - The product ID of the selected product.
 * @param {number} storeId - The store ID selected for in store pickup.
 * @param {string} actionURL - The action url for this context
 */
function updateQuantityOptions(searchPID, storeId, actionURL) {
    // TODO double check this (may be needed for sets / bundles)
    // var selectorPrefix = '.product-detail[data-pid="' + searchPID + '"]';
    // var productIdSelector = selectorPrefix + ' .product-id';
    var quantitySelector = isCart ? 'select[data-uuid=' + currentUUID + ']' : '.attribute.quantity .quantity-select';
    var quantityOptionSelector = quantitySelector + ' option';

    setOriginalQuantitySelect($(quantitySelector));

    var requestData = {
        pid: isCart ? $(quantitySelector).data('pid') : $('.product-id').text(),
        quantitySelected: $(quantitySelector).find('option:selected').val(),
        storeId: storeId
    };

    $.ajax({
        url: actionURL,
        data: requestData,
        method: 'GET',
        success: function (response) {
            // Update Quantity dropdown, Remove quantity greater than inventory
            var productAtsValue = response.atsValue;
            var availabilityValue = '';

            // eslint-disable-next-line sonarjs/no-duplicate-string
            var $productContainer = isCart ? $('.current-store[data-uuid=' + currentUUID + ']') : $('.product-detail[data-pid="' + searchPID + '"]');

            if (!response.product.readyToOrder) {
                availabilityValue = '<div>' + response.resources.info_selectforstock + '</div>';
            } else {
                response.product.messages.forEach(function (message) {
                    availabilityValue += '<div>' + message + '</div>';
                });
            }

            $($productContainer).trigger('product:updateAvailability', {
                product: response.product,
                $productContainer: $productContainer,
                message: availabilityValue,
                resources: response.resources
            });

            $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCartBopis', {
                product: response.product, $productContainer: $productContainer
            });

            updateQOptions(quantitySelector, quantityOptionSelector, productAtsValue);
        },
        error: function (err) {
            // eslint-disable-next-line no-console
            console.error('Error while updating quantity options: ' + err.message);
        }
    });
}

/**
 * Update the messaging on the PDP for the Pick Up In Store Message
 * @param {boolean} isSizeSelected - If a size is selected on the PDP
 * @param {boolean} isStoreSelected - If a store is selected on the PDP
 * @param {number} storeATS - The store's Available to Sell inventory
 * @param {string} [storeInventoryMessageTemplate] - The template for the product store inventory message (optional)
 */
function updatePISMessage(isSizeSelected, isStoreSelected, storeATS, storeInventoryMessageTemplate) {
    const HIDDEN = 'd-none';
    let textToShow = '';
    let textToHide = ['#js-js-store-ats-select-variant-and-location', '#js-store-ats-select-variant', '#js-store-ats-select-location', storeATSClass];

    // render updated template
    if (storeInventoryMessageTemplate && isSizeSelected && isStoreSelected && storeATS >= 0) {
        $('.store-inventory-messaging').html(storeInventoryMessageTemplate);
    }

    // Always update this so it's available for other functions
    $('#store-ats').attr('data-store-ats', storeATS);

    if (!isSizeSelected && !isStoreSelected) {
        textToShow = '#js-js-store-ats-select-variant-and-location';
    } else if (!isSizeSelected) {
        textToShow = '#js-store-ats-select-variant';
    } else if (!isStoreSelected) {
        textToShow = '#js-store-ats-select-location';
    } else {
        textToShow = storeATSClass;
    }

    for (var i = 0; i < textToHide.length; i += 1) {
        $(textToHide[i]).addClass(HIDDEN);
    }

    $(textToShow).removeClass(HIDDEN);
}

/**
 * Enabling and disabling add to cart based on BOPIS selections and ATS
 * @param {boolean} updateMessage - Flag to indicate if the PIS message should be updated - Done on initial button click
 */
function showPickupStoreRadio(updateMessage) {
    const addToCartButton = document.querySelector('.add-to-cart');
    const productAttributes = document.getElementById('productAtributes');
    const isUnavailableVariationAttributeSelected = productAttributes && productAttributes.getElementsByClassName('selected unselectable').length > 0;

    if (!isUnavailableVariationAttributeSelected && addToCartButton) {
        addToCartButton.removeAttribute('disabled');
    }

    // If bopis is not checked, return early and avoid extra processing
    const $bopisMethodRadioButton = document.getElementById('bopisMethodRadioButton');
    const isBopisChecked = $bopisMethodRadioButton && $bopisMethodRadioButton.checked;
    if (!isBopisChecked) {
        return;
    }

    // Get the bopis details
    const storeDetails = document.querySelector('#minimal-store-details');
    const isStoreSelected = storeDetails && Boolean(storeDetails.getAttribute('data-store-id'));
    const storeATSCountElement = document.getElementById('store-ats');
    const storeATSCount = storeATSCountElement ? parseInt(storeATSCountElement.getAttribute('data-store-ats'), 10) : 0;

    let isSizeSelected = document.querySelector(sizeSelectedClasses);

    // If it is a bra, we should also check for a cup value
    if (document.querySelectorAll('.cup-value').length) {
        const isCupSelected = document.querySelector('.cup-value.selected');
        isSizeSelected = isSizeSelected && isCupSelected;
    }

    // Update the PIS message, this is used when showing the radio button
    if (updateMessage) {
        updatePISMessage(isSizeSelected, isStoreSelected, storeATSCount);
    }

    // If we don't have a size, store, or ATS, disable the ATC button
    const isInvalidSizeOrStore = !isSizeSelected || !isStoreSelected;
    const isInvalidStoreATSCount = Number.isNaN(storeATSCount) || storeATSCount < 1;

    if ((isInvalidSizeOrStore || isInvalidStoreATSCount) && addToCartButton) {
        addToCartButton.setAttribute('disabled', true);
    }
}

module.exports = {
    bindEnterKeyToRadioSelect: function () {
        $(document).on('keydown', '.js-radio-btn-label', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                const $input = $(this).find('input');
                $input.prop('checked', true);
                $input.trigger('change');
            }
        });
    },
    updateSelectStore: function () {
        $('body').on('product:updateAddToCartBopis', function (e, response) {
            $(inStoreInventoryBtnClass, response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available
                || !response.product.availableForInStorePickup));
        });
    },
    removeSelectedStoreOnAttributeChange: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            response.container.attr('data-pid', response.data.product.id);
        });
    },
    updateAddToCartFormData: function () {
        $('body').on('updateAddToCartFormData', function (e, form) {
            if (form.pidsObj) {
                var pidsObj = JSON.parse(form.pidsObj);
                pidsObj.forEach(function (product) {
                    var storeElement = $('.product-detail[data-pid="'
                        + product.pid
                        + '"]').find(storeNameClass);
                    product.storeId = $(storeElement).length// eslint-disable-line no-param-reassign
                        ? $(storeElement).attr(dataStoreIDAttr)
                        : null;
                });

                form.pidsObj = JSON.stringify(pidsObj);// eslint-disable-line no-param-reassign
            }

            var storeElement = $('.product-detail[data-pid="'
                + form.pid
                + '"]');

            if ($(storeElement).length && $(bopisMethodRadioBtnID).is(':checked')) {
                if (!$(storeNameClass).attr(dataStoreIDAttr)) {
                    form.storeId = $(storeElement).find('.store-details') // eslint-disable-line
                        .attr(dataStoreIDAttr);
                } else {
                    form.storeId = $(storeElement).find(storeNameClass) // eslint-disable-line
                        .attr(dataStoreIDAttr);
                }
            }
        });
    },
    showInStoreInventory: function () {
        $(inStoreInventoryBtnClass).on('click', function (e) {
            var pid = $(this).closest(productDetailClass).attr('data-pid');
            var quantity = $(this).closest(productDetailClass).find(quantitySelectClass).val();
            getModalHtmlElement();
            fillModalElement(pid, quantity);
            e.stopPropagation();
        });
    },
    selectStoreWithInventory: function () {
        $('body').on('store:selected', function (e, data) {
            var $storeFinderModal = $('#storeFinderModal');
            var $shippingRadioButton = $('#shippingMethodRadioButton');
            var $bopisMethodRadioButton = $(bopisMethodRadioBtnID);
            var searchPID = $('.btn-storelocator-search').data('search-pid');
            var storeElement = $('.product-detail[data-pid="' + searchPID + '"]');
            $(storeElement).find('.store-details').attr(dataStoreIDAttr, data.storeID);

            var $changeStoreButton = $(storeElement).find('.change-store');

            var requestData = {
                storeId: data.storeID,
                pid: searchPID
            };
            var actionURL = $changeStoreButton.data('store-info-action-url');
            $.ajax({
                url: actionURL,
                data: requestData,
                method: 'GET',
                success: function (response) {
                    $(storeElement).find('.store-map-link').html(response.storeNavigationHtml);
                    $(storeElement).find('.store-details-state').text(response.stateCode);
                    $(storeElement).find('.selected-store-with-inventory').removeClass('d-none');

                    let isSizeSelected = document.querySelector(sizeSelectedClasses);

                    // If it is a bra, we should also check for a cup value
                    if (document.querySelectorAll('.cup-value').length) {
                        const isCupSelected = document.querySelector('.cup-value.selected');
                        isSizeSelected = isSizeSelected && isCupSelected;
                    }

                    updatePISMessage(isSizeSelected, true, response.storeATS, response.storeInventoryMessageTemplate);
                    showPickupStoreRadio();

                    $(storeElement).find('.change-store-text').removeClass('d-none');
                    $(storeElement).find('.select-store-text').addClass('d-none');
                    $bopisMethodRadioButton.data('storeId', response.ID);

                    // store was selected after user was prompted to select a store for BOPIS fulfillment
                    if ($storeFinderModal.length && $storeFinderModal.data('prompt-store-selection')) {
                        $storeFinderModal.data('prompt-store-selection', false);
                        $bopisMethodRadioButton.prop('checked', true);
                        $shippingRadioButton.prop('checked', false);
                        $('.js-radio-btn').trigger('change');
                    }
                },
                error: function (err) {
                    // eslint-disable-next-line no-console
                    console.error('Error while getting store info: ' + err.message);
                }
            });
            $($changeStoreButton).data('postal', data.searchPostalCode);
            $($changeStoreButton).data('radius', data.searchRadius);

            $(storeElement).find(inStoreInventoryBtnClass).hide();

            updateQuantityOptions(searchPID, data.storeID, $changeStoreButton.data('action-url'));
            $(inStoreInventoryModalID).modal('hide');
            $(inStoreInventoryModalID).remove();
        });
    },
    changeStore: function () {
        const setPostalCode = function () {
            /* eslint-disable no-useless-concat */
            // Check cookies to see if user has updated their requested ZIP Code, and if the cookie exists update DOM elements
            var requestedPostalCode = document.cookie.match(new RegExp('(^| )' + 'requestedPostalCode' + '=([^;]+)'));
            requestedPostalCode = requestedPostalCode ? requestedPostalCode[2] : null;

            if (requestedPostalCode) {
                $('.change-store').each(function () {
                    $(this).data('postal', requestedPostalCode);
                });
            }
        };

        setPostalCode();
        $('body').on('bopis:pdpBlockLoaded', setPostalCode);
    },
    updatePISMessage: updatePISMessage,
    showPickupStoreRadio: showPickupStoreRadio
};
